// extracted by mini-css-extract-plugin
module.exports = {"hero":"styles_hero__x5AcI","headingText":"styles_headingText__lBAh9","text":"styles_text__xWn5d"};